import { render, staticRenderFns } from "./MyPageTop.vue?vue&type=template&id=5ed83017&scoped=true&"
import script from "./MyPageTop.vue?vue&type=script&lang=ts&"
export * from "./MyPageTop.vue?vue&type=script&lang=ts&"
import style0 from "./MyPageTop.vue?vue&type=style&index=0&id=5ed83017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed83017",
  null
  
)

export default component.exports